

export const addItemToCart = (cartItems, qty, cartItemToAdd,products) => {
   
   
    const existingCartItem = cartItems.find(cartItem => cartItem.sku === cartItemToAdd.sku);
    if (existingCartItem) {
        if (qty > getQuantity(existingCartItem.sku, products)) {
            alert('You cannot order more than what we have in the store')
            return cartItems;
        } else {
            return cartItems.map(cartItem => cartItem.sku === cartItemToAdd.sku ? { ...cartItem, quantity: qty } : cartItem)
        }
    } else {

        if (qty > getQuantity(cartItemToAdd.sku, products)) {
            alert('You cannot order more than what we have in the store')
            return cartItems;
        } else {
            return [...cartItems, { ...cartItemToAdd, quantity: qty }]
        }

       

    }
}

export const addRefundToCart = (refundItems, refundItemTAdd,store) => {
    const existingCartItem = refundItems.find(refundItem => refundItem.sku === refundItemTAdd.sku);
    if (existingCartItem) {
        return refundItems.map(refundItem => refundItemTAdd.sku === refundItemTAdd.sku ? { ...refundItem, quantitys: 2 } : refundItem)
    } else {
        return [...refundItems, { ...refundItemTAdd }]
    }

}

export const addQuantityOfItemToCart = (cartItems, cartItemToAdd,products) => {

    const existingCartItem = cartItems.find(cartItem => cartItem.sku === cartItemToAdd.sku);
    let selectedQuantity = cartItemToAdd.selectedQuantity;
    if (existingCartItem) {
        const existingCartItem = cartItems.find(cartItem => cartItem.sku === cartItemToAdd.sku);
        if ((existingCartItem.quantity + selectedQuantity) > getQuantity(selectedQuantity, products)) {
            alert('You cannot order more than what we have in the store')
            return cartItems;
        } else {
            return cartItems.map(cartItem => cartItem.sku === cartItemToAdd.sku ? { ...cartItem, quantity: cartItem.quantity + selectedQuantity } : cartItem)
        }
    } else {
        return [...cartItems, { ...cartItemToAdd, quantity: selectedQuantity }]
    }

}


export const addItemsToCart = (cartItems, cartItemToAdd) => {
    var currentQuantity = 0;
    const existingCartItem = cartItems.find(cartItem => cartItem.sku === cartItemToAdd.sku);
    if (existingCartItem) {
        if (existingCartItem.quantity > existingCartItem.quantityy) {
            alert('You cannot order more than what we have in the store')
        }
        return cartItems.map(cartItem => cartItem.sku === cartItemToAdd.sku ? { ...cartItem, quantity: cartItem.quantity + cartItemToAdd.quantity } : cartItem)
    }
    if (cartItemToAdd.quantityy < 1) {
        alert('You cannot order more than what we have in the store')
    }
    return [...cartItems, { ...cartItemToAdd, quantity: cartItemToAdd.quantity }]
}


export const RemoveItemFromCart = (cartItems, cartItemToRemove) => {

    const existingCartItem = cartItems.find(cartItem => cartItem.sku === cartItemToRemove.sku);

    if (existingCartItem.quantity === 1) {
        return cartItems.filter(cartItem => cartItem.id !== cartItemToRemove.id)
    }
    return cartItems.map(


        cartItem => cartItem.sku === cartItemToRemove.sku ?
            { ...cartItem, quantity: cartItem.quantity - 1 } : cartItem
    )
}


let getQuantity = (sku, products) => {
    for (var i = 0; i < products.length; i++) {
        console.log(products[i].sku)
        console.log(sku)
        if (products[i].sku == sku) {
           
            return products[i].quantityy
        }
    }
}
